<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>cube_3d</title>
    <path
      fill="#679940"
      d="M28.427 9.76c0-0.053-0.053-0.053-0.107-0.107v-0.053c-0.053-0.053-0.053-0.107-0.107-0.107l-11.787-8.053c-0.267-0.16-0.587-0.16-0.853 0l-11.787 8.053c-0.053 0.053-0.107 0.107-0.107 0.107l-0.053 0.053c0 0-0.053 0.053-0.053 0.053-0.053 0.107-0.107 0.267-0.107 0.373v11.68c0 0.267 0.107 0.48 0.32 0.64l11.68 8.053c0.107 0.107 0.267 0.107 0.427 0.107 0.053 0 0.053 0 0.107 0 0 0 0.053 0 0.107 0 0.16 0 0.32-0.053 0.427-0.107l11.68-8.053c0.213-0.16 0.32-0.373 0.32-0.64v-11.68c0-0.053-0.053-0.16-0.107-0.32zM15.147 18.613v9.813l-10.187-7.040v-9.813l10.187 7.040zM26.453 10.133l-10.453 7.147-10.453-7.147 10.453-7.147 10.453 7.147zM26.987 11.573v9.813l-10.187 7.040v-9.813l10.187-7.040z"
    />
  </svg>
</template>

<script>
export default {
  name: "InventarioIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/InventarioIcon.vue